import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, Provider, ReactReduxContext } from 'react-redux';
import { Map, GoogleApiWrapper, InfoWindow } from 'google-maps-react';
import { __RouterContext as RouterContext, Router } from 'react-router';

import EventHelper from '../../helpers/Event';
import OfferBox from '../OfferBox';
import MarkerCluster from './MarkerCluster';
import events from '../../redux/actions/events';
import insailingPropTypes from '../../redux/propTypes';

class ResultsMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showingInfoWindow: false,
      boundsCheck: '',
      infoBlock: '',
    };
    this.fetchPlaces = this.fetchPlaces.bind(this);
    this.getPrice = this.getPrice.bind(this);
    this.mapRef = null;
  }

  // eslint-disable-next-line react/sort-comp
  async fetchPlaces(mapProps, map) {
    const { boundsResults, google } = this.props;
    if (boundsResults) {
      map.setCenter(
        new google.maps.LatLng(
          Number(boundsResults.cen_lat),
          Number(boundsResults.cen_lng),
        ),
      );
      map.setZoom(Number(boundsResults.zum));
      this.forceUpdate();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  getPrice(ev) {
    const { locale, currency } = this.props;
    const eventHelper = new EventHelper(ev);
    const price = eventHelper.getBestPriceSimplifeidEvents(
      currency.current,
      locale.current,
    );
    return price;
  }

  onMarkerClick = () => {
    this.setState({
      showingInfoWindow: true,
    });
    this.forceUpdate();
  };

  onMapClicked = () => {
    const { showingInfoWindow } = this.state;
    if (showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
      });
      this.forceUpdate();
    }
  };

  render() {
    const { google, route, boundsChange, event, locale, t, currency } =
      this.props;

    const { infoBlock, boundsCheck } = this.state;
    const that = this;
    const bounds = new google.maps.LatLngBounds();
    const initialCoord = { lat: 29.291048844212423, lng: -4.294416000000001 };
    const path = [];
    const coordsAll = route;
    for (let i = 0; i < coordsAll.length; i += 1) {
      const c = coordsAll[i];
      if (c && c.lat && c.lng) {
        bounds.extend({ lat: c.lat, lng: c.lng });
        path.push({ lat: c.lat, lng: c.lng });
      }
    }
    const style = {
      color: 'white',
    };

    return (
      <Map
        onClick={(props) => {
          this.onMapClicked(props);
          if (infoBlock) {
            this.setState({
              infoBlock: '',
            });
            this.forceUpdate();
          }
        }}
        ref={(ref) => {
          this.mapRef = ref;
        }}
        google={google}
        zoom={2}
        style={style}
        initialCenter={initialCoord}
        onReady={this.fetchPlaces}
        onIdle={(e, map) => {
          if (!boundsChange) {
            return null;
          }
          // eslint-disable-next-line no-shadow
          const bounds = map.getBounds();
          if (JSON.stringify(boundsCheck) !== JSON.stringify(bounds)) {
            this.setState({ boundsCheck: bounds });
            this.forceUpdate();
            const ne = bounds.getNorthEast().toJSON();
            const sw = bounds.getSouthWest().toJSON();
            boundsChange({
              tl_lat: ne.lat,
              tl_lon: sw.lng,
              br_lat: sw.lat,
              br_lon: ne.lng,
              zum: map.getZoom(),
              cen_lat: map.getCenter().toJSON().lat,
              cen_lng: map.getCenter().toJSON().lng,
            });
          } else if (boundsChange) this.forceUpdate();
        }}
      >
        {path && path.length && (
          <MarkerCluster
            markers={path}
            click={this.onMarkerClick}
            mouseover={this.onMouseOver}
            mouseout={this.onMouseOut}
            boundsChange={boundsChange}
            event={event}
            currency={() => t('purchase.price')}
            getPrice={this.getPrice}
            // eslint-disable-next-line no-shadow
            onClickInfo={(infoBlock, cb) => {
              // eslint-disable-next-line react/prop-types
              const { dispatch } = this.props;
              dispatch(
                events.getEvents(infoBlock.index.slug, (err, eventN) => {
                  const copyInfoBlock = { ...infoBlock };
                  copyInfoBlock.index = { ...eventN[0] };
                  this.setState({ infoBlock: copyInfoBlock });
                }),
              );
              this.forceUpdate();
              cb();
            }}
            locale={locale && locale.current}
            currencyLog={currency && currency.current}
          />
        )}
        <RouterContext.Consumer>
          {({ history }) => (
            <ReactReduxContext.Consumer>
              {({ store }) =>
                that.mapRef && (
                  <InfoWindow
                    position={infoBlock ? infoBlock.position : {}}
                    visible={!!infoBlock}
                    disableAutoPan={!!infoBlock}
                    zIndex={100000}
                    google={google}
                    map={that.mapRef.map}
                    mapCenter={that.mapRef.state.currentLocation}
                  >
                    {event && event.length && infoBlock.index && (
                      <Provider store={store}>
                        <Router history={history}>
                          <OfferBox event={infoBlock.index} forMap />
                        </Router>
                      </Provider>
                    )}
                  </InfoWindow>
                )
              }
            </ReactReduxContext.Consumer>
          )}
        </RouterContext.Consumer>
      </Map>
    );
  }
}

ResultsMap.propTypes = {
  google: PropTypes.shape().isRequired,
  locale: insailingPropTypes.locale.isRequired,
  boundsResults: PropTypes.shape({
    cen_lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    cen_lng: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    zum: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  currency: insailingPropTypes.currency.isRequired,
  boundsChange: PropTypes.func,
  t: PropTypes.func.isRequired,
  event: PropTypes.arrayOf(PropTypes.shape()),
  route: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

ResultsMap.defaultProps = {
  event: null,
  boundsResults: null,
  boundsChange: null,
};

function mapStateToProps(state) {
  return {
    locale: state.locale,
    currency: state.currency,
  };
}

export default connect(mapStateToProps)(
  GoogleApiWrapper({
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
  })(ResultsMap),
);
